import { render, staticRenderFns } from "./homeNewsParticulars.vue?vue&type=template&id=caa13fd4&scoped=true&"
import script from "./homeNewsParticulars.vue?vue&type=script&lang=js&"
export * from "./homeNewsParticulars.vue?vue&type=script&lang=js&"
import style0 from "./homeNewsParticulars.vue?vue&type=style&index=0&id=caa13fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa13fd4",
  null
  
)

export default component.exports